<!--
 * @Description: 销售线索 - 编辑页面
 * @Author: mdb
 * @Date: 2022-07-06 11:38:03
 * @LastEditTime: 2022-11-23 16:58:59
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <DetailForm
        ref="detailFormRef"
        type="edit"
        isEdit
        v-model:value="dataForm"
        :clueTypeDisabled="clueTypeDisabled"
        :resetValue="initForm"
      />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { ref, reactive, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import DetailForm from './components/DetailForm.vue'
import { salesClueDetail } from '@/api/gucangSales/clueManage'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
const route = useRoute()

const initForm: FbuSalesClueEditParams.RootObject = reactive({
  contact: {},
  business: { demandInfo: { warehouses: [{}] }, saleInfo: [{}] },
  visitAddress: [{}]
})
const dataForm = reactive<FbuSalesClueEditParams.RootObject>(cloneDeep(initForm))
const clueTypeDisabled = ref(false)

onBeforeMount(() => {
  salesClueDetail({ clueId: route.query.clueId as string }).then((res) => {
    if (res.data.remindFlag === true) {
      res.data.remindFlag = 1
    } else if (res.data.remindFlag === false) {
      res.data.remindFlag = 0
    } else {
      res.data.remindFlag = undefined
    }
    if ([1, 3].includes(res.data.clueType)) {
      clueTypeDisabled.value = true
    }
    if (res.data.visitAddress == null || res.data.visitAddress?.length === 0) {
      res.data.visitAddress = [{}]
    }
    Object.assign(initForm, res.data)
    Object.assign(dataForm, res.data)
  })
})
</script>
<script lang="ts">
export default { name: 'DcCosFbuSalesClueEdit' }
</script>

<style scoped></style>
